import { createContext, useContext, useState, useEffect } from 'react';
import API_CONFIG from '../config/api';
import { clearAuthData } from '../utils/auth';
const AuthContext = createContext(null);
export { AuthContext };

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const login = async (email, password) => {
    if (!password) {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No token found');
      }
      const response = await API_CONFIG.client.get(
        API_CONFIG.ENDPOINTS.AUTH.ME
      );
      setUser(response.data);
      setIsAuthenticated(true);
      return true;
    }
    throw new Error('Email/password authentication is not supported');
  };
  const logout = async () => {
    try {
      await API_CONFIG.client.post(API_CONFIG.ENDPOINTS.AUTH.LOGOUT);
    } catch (error) {
      console.error('Error logging out:', error);
    } finally {
      clearAuthData();
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  const updateUser = updatedUserData => {
    setUser(prevUser => ({
      ...prevUser,
      ...updatedUserData,
    }));
  };

  const value = {
    user,
    isAuthenticated,
    loading,
    login,
    logout,
    updateUser,
  };

  useEffect(() => {
    const initializeAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await API_CONFIG.client.get(
            API_CONFIG.ENDPOINTS.AUTH.ME
          );
          setUser(response.data);
          setIsAuthenticated(true);
        } catch (error) {
          clearAuthData();
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    initializeAuth();
  }, []);

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
